import { Component, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import {
  CheckboxComponent,
  DatePipe,
  DropdownComponent,
  DropdownItemComponent,
  FormComponent,
  FormRowComponent,
  IconComponent,
  InputDirective,
  InputErrorsComponent,
  InputGroupComponent,
  InputGroupFieldComponent,
  InputGroupLabelComponent,
  InputStatusIndicatorDirective,
  NotificationComponent,
  TranslatePipe
} from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';
import { Titles, TitleNeedsNameValidatorDirective } from './title-needs-name-validator.directive';
export interface NasdaqAgreementFormModel {
  professionalIndicator: boolean
  clientName: string
  signature: string
  agentName: string
  subscriberAgentTitle: string
  titles: Record<Titles, boolean>
}
@Component({
  selector: 'td-wb-nasdaq-agreement',
  templateUrl: './nasdaq-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [
    NgTemplateOutlet,
    FormsModule,
    TranslateDirective,
    NotificationComponent,
    DatePipe,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    InputDirective,
    InputErrorsComponent,
    InputStatusIndicatorDirective,
    DropdownComponent,
    DropdownItemComponent,
    CheckboxComponent,
    IconComponent,
    TranslatePipe,
    TitleNeedsNameValidatorDirective
  ]
})
export class NasdaqAgreementComponent extends AgreementsDateBaseDirective {
  protected readonly form = viewChild(FormComponent);
  collapsed: boolean = false;
  formModel: NasdaqAgreementFormModel = {
    professionalIndicator: undefined,
    clientName: '',
    signature: '',
    agentName: '',
    subscriberAgentTitle: '',
    titles: {
      CEO: false,
      COO: false,
      DIRECTOR: false,
      PRESIDENT: false,
      SVP: false,
      VP: false
    }
  };

  trySubmitAndReturnModel(): NasdaqAgreementFormModel {
    const form = this.form();
    return form !== undefined && super.trySubmit(form) ? this.formModel : undefined;
  }
}
